export const S3_BASE_URL = 'https://rs.vietnamyosakoi.com';

/** Prepend S3_BASE_URL to a relative path from the DB.
 *  Returns the fallback image if path is falsy. */
export function s3(path: string | null | undefined, fallback = 'images/placeholder.jpg'): string {
    return path ? `${S3_BASE_URL}/${path}` : fallback;
}
